module.exports = __webpack_public_path__ + "img/center front length.7ddc82f8.png";